import i18n from '@/locales'

export const ResourceKeyLabelsMap = {
  name: i18n.t('common_186'),
  ip: 'IP',
  ips: 'IPs',
  cloudaccount_id: i18n.t('common_295') + ' ID',
  account: i18n.t('common_295'),
  account_id: i18n.t('common_295') + ' ID',
  vm_id: i18n.t('common_239') + ' ID',
  brand: i18n.t('common_283'),
  cloudregion: i18n.t('common_282'),
  cloudregion_id: i18n.t('common_282') + ' ID',
  domain_id: i18n.t('common_437') + ' ID',
  host: i18n.t('common_305'),
  host_id: i18n.t('common_305') + ' ID',
  host_type: i18n.t('common_56'),
  os_type: i18n.t('scope.text_27'),
  project_domain: i18n.t('table.title.owner_domain'),
  region_ext_id: i18n.t('compute.external_region') + ' ID',
  status: i18n.t('scope.text_426'),
  tenant: i18n.t('dictionary.project'),
  tenant_id: i18n.t('dictionary.project') + ' ID',
  res_type: i18n.t('common.resource_type'),
  vcpu_count: 'CPU',
  vmem_size: i18n.t('compute.text_168'),
  vpc: 'VPC',
  vpc_id: 'VPC ID',
  zone: i18n.t('scope.text_22'),
  zone_id: i18n.t('scope.text_22') + ' ID',
  hostname: i18n.t('common_186'),
}
